import React from "react";
import "./card.css";

const Card = ({ title, subTitle, icon, revers }) => {
  const background = revers
    ? "linear-gradient(71.03deg, #FFFFFF 12.79%, rgba(255, 255, 255, 0) 87.21%)"
    : "linear-gradient(71.03deg, rgba(255, 255, 255, 0) 12.79%, #FFFFFF 87.21%)";

  return (
    <div
    // style={{
    //   border: "1px solid",
    //   borderImageSource:
    //     "linear-gradient(174.84deg, rgba(226, 226, 226, 0) 28.87%, #E2E2E2 100.62%);",
    // }}
    >
      <div
        style={{
          background,
        }}
        className="flex flex-col items-start py-8 px-6 justify-start gradient-border "
      >
        <div>{icon}</div>
        <div className="space-y-2 pt-[10px]">
          <h2 className="text-2xl font-semibold text-[#1C1C1C]">{title}</h2>
          <p className="text-base font-medium text-[#5D5D5D] ">{subTitle}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
